import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ValidationDtls } from "src/generic/test-connection/test-connection";

export interface TestConnectionData {
    showAgentModal: boolean;
    loading: boolean;
    errorMsg: string | null;
    connectionSuccess: boolean;
    lastValidationDate: string | null;
    unavailableDriverDBType: string | null;
    lastOnTestValidationDtls?: ValidationDtls;
    currentValidationDtls?: ValidationDtls;
}

interface SidebarState {
    testConnectionData: TestConnectionData;
}

const initialTestConnectionData: TestConnectionData = {
    showAgentModal: false,
    loading: false,
    errorMsg: null,
    connectionSuccess: false,
    lastValidationDate: null,
    unavailableDriverDBType: null,
    lastOnTestValidationDtls: undefined,
    currentValidationDtls: undefined
};

const initialState: SidebarState = {
    testConnectionData: initialTestConnectionData
};

const sidebarSlice = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        setShowAgentModalAction: (state, action: PayloadAction<boolean>) => {
            state.testConnectionData.showAgentModal = action.payload;
        },
        setTestConnectionLoadingAction: (state, action: PayloadAction<boolean>) => {
            state.testConnectionData.loading = action.payload;
        },
        setTestConnectionErrorMsgAction: (state, action: PayloadAction<string | null>) => {
            state.testConnectionData.errorMsg = action.payload;
        },
        setConnectionSuccessAction: (state, action: PayloadAction<boolean>) => {
            state.testConnectionData.connectionSuccess = action.payload;
        },
        setLastValidationDateAction: (state, action: PayloadAction<string | null>) => {
            state.testConnectionData.lastValidationDate = action.payload;
        },
        setUnavailableDriverDBTypeAction: (state, action: PayloadAction<string | null>) => {
            state.testConnectionData.unavailableDriverDBType = action.payload;
        },
        setLastOnTestValidationDtlsAction: (state, action: PayloadAction<ValidationDtls | undefined>) => {
            state.testConnectionData.lastOnTestValidationDtls = action.payload;
        },
        setCurrentValidationDtlsAction: (state, action: PayloadAction<ValidationDtls | undefined>) => {
            state.testConnectionData.currentValidationDtls = action.payload;
        },
        resetTestConnectionDataAction: state => {
            state.testConnectionData = initialTestConnectionData;
        }
    }
});

export const {
    setShowAgentModalAction,
    setTestConnectionLoadingAction,
    setTestConnectionErrorMsgAction,
    setConnectionSuccessAction,
    setLastValidationDateAction,
    setUnavailableDriverDBTypeAction,
    setLastOnTestValidationDtlsAction,
    setCurrentValidationDtlsAction,
    resetTestConnectionDataAction
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
